import "./Skills.scss";
import bgSkills from "/images/Skills.jpg";
import DomeGallery from "../../UI/DomeGallery/DomeGallery";
import SectionTitle from "../../UI/SectionTitle/SectionTitle";
import skillsData from "../../UI/DomeGallery/SlillsData";

const Skills = () => {
  return (
    <section className="skills" id="skills">
      <picture className="skills__bg">
        <img
          className="skills__bg-img"
          src={bgSkills}
          alt="Код на заднем фоне"
        />
      </picture>

      <div className="container">
        <div className="skills__wrapper">
          <SectionTitle
            title="Навыки"
            description="Я&nbsp;стремлюсь никогда не&nbsp;прекращать учиться
              и&nbsp;совершенствоваться"
            icon="/"
          />

          <div
            className="skills__content"
            style={{ width: "100%", height: "600px" }}
          >
            <DomeGallery
              images={skillsData}
              grayscale={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
